/**
 * @namespace userAgent
 * @desc Mit Hilfe von {@link https://github.com/naver/egjs-agent|@egjs/agent} extrahierte Informationen zum Browser
 * (<i>client</i>) und mobilem Gerät (<i>mobile</i>).
 */
import agent from '@egjs/agent';

const userAgent = {};
const {navigator, parseFloat} = globalThis;
const {os, browser, isMobile} = agent();

/** Die wichtigsten Browser.
 * @alias userAgent.client
 * @type {Object}
 * @property {number} chrome - 0 oder major version
 * @property {number} firefox - 0 oder major version
 * @property {number} safari - 0 oder major version
 * @property {number} ie - 0 oder major version
 * @property {number} edge - 0 oder major version
 * @property {number} webkit - 0 oder major version
 * @property {string} version - Nicht mehr unterstützt!
 */
const client = {
    ie: 0,
    safari: 0,
    firefox: 0,
    chrome: 0,
    edge: 0,
    webkit: 0
};

if (browser.chromium)
{
    client.chrome = parseFloat(browser.chromiumVersion);
}

if (browser.webkit)
{
    client.webkit = parseFloat(browser.webkitVersion);
}

switch (browser.name)
{
    case 'chrome':
        client.chrome = browser.majorVersion; break;
    case 'firefox':
        client.firefox = browser.majorVersion; break;
    case 'safari':
        client.safari = browser.majorVersion; break;
    case 'ie':
        client.ie = browser.majorVersion; break;
    case 'edge':
        client.edge = browser.majorVersion; break;
    default:
}

/** Ist das Gerät ein Handy oder Tablet?
 * @alias userAgent.mobile
 * @type {Object}
 * @property {boolean} general
 * @property {boolean} ios
 * @property {boolean} windows - Nicht mehr unterstützt!
 * @property {boolean} android
 */
const mobile = {
    general: false,
    ios: false,
    android: false
};

if (
    os.name === 'ios' ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
)
{
    mobile.general = true;
    mobile.ios = true;
}
else if (os.name === 'android')
{
    mobile.general = true;
    mobile.android = true;
}
else if (isMobile)
{
    mobile.general = true;
}

userAgent.mobile = mobile;
userAgent.client = client;

Object.freeze(mobile);
Object.freeze(client);
Object.freeze(userAgent);

export default userAgent;
